<template>
  <div>
    <div class="buttons">
      <template v-for="(button, index) in config.buttons">
        <button
          @click="
            onClickEvent(
              button.buttonId,
              button.require ? button.require : false,
              button.limitRequire ? button.limitRequire : 0
            )
          "
          :key="index"
          class="draw meet"
        >
          <i v-bind:class="[button.icon]"></i> {{ button.text }}
        </button>
        <!-- <button :key="index" @click="onClickEvent(button.buttonId,(button.require)?button.require:false,(button.limitRequire)?button.limitRequire:0)" class="ui blue basic button"><i v-bind:class="[button.icon]"></i> {{button.text}} </button>
            --></template
      >
    </div>
    <div style="float: right">
      <input v-model="filter" @input="startfilter()" type="text" placeholder="Buscar..." />
    </div>

    <table class="rwd-table">
      <tbody>
        <tr>
          <template v-for="(field, index) in config.fields">
            <th :key="index">{{ field.title }}</th>
          </template>
        </tr>

        <template v-for="(row, index) in dataShowed">
          <tr
            :key="index"
            @click="
              selectRows(
                config.selectConfig ? row[config.selectConfig.idRowData] : ''
              )
            "
            v-bind:class="[
              selectedRows.includes(
                row[config.selectConfig ? config.selectConfig.idRowData : '']
              )
                ? 'selectedRow'
                : '',
            ]"
          >
            <template v-for="(field, indexField) in config.fields">
              <td :data-th="field.title" v-if="!field.format" :key="indexField">
                {{ row[field.dataName] }}
              </td>
              <td
                :data-th="field.title"
                v-if="field.format"
                :key="indexField"
                v-html="field.format(row)"
              ></td>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
      <v-row
        v-if="data.length==0 && !notData"
        class="fill-height"
        align-content="center"
        justify="center"
      >
        <v-col
          class="subtitle-1 text-center"
          cols="12"
        >
          Cargando Información
        </v-col>
        <v-col cols="6">
          <v-progress-linear
            :color="this.$pgsHelper.uiConfig().mainColor"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
    <div style="display: flex; justify-content: space-between">
      <div style="margin-left: auto; margin-right: 0">
        <ul class="uvpagination modal-1">
          <li>
            <a
              href="javascript:void(0)"
              @click="setPage(selectedPage - 1)"
              class="prev"
              >&laquo;</a
            >
          </li>
          <template v-for="(pages, index) in pagesShow">
            <li @click="setPage(pages)" :key="index" class="">
              <a
                href="javascript:void(0)"
                v-bind:class="[selectedPage == pages ? 'active' : '']"
                >{{ pages }}</a
              >
            </li>
          </template>
          <li>
            <a
              href="javascript:void(0)"
              @click="setPage(selectedPage + 1)"
              class="next"
              >&raquo;</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
button {
  background: none;
  border: 0;
  box-sizing: border-box;
  padding: 1em 2em;
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.08);
  color: #767676d6;
  font-size: inherit;
  font-weight: 700;
  position: relative;
  vertical-align: middle;
}
button::before,
button::after {
  box-sizing: inherit;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
}
.draw {
  -webkit-transition: color 0.25s;
  transition: color 0.25s;
}
.draw::before,
.draw::after {
  border: 2px solid transparent;
  width: 0;
  height: 0;
}
.draw::before {
  top: 0;
  left: 0;
}
.draw::after {
  bottom: 0;
  right: 0;
}
.draw:hover {
  color: #60daaa;
}
.draw:hover::before,
.draw:hover::after {
  width: 100%;
  height: 100%;
}
.draw:hover::before {
  border-top-color: #60daaa;
  border-right-color: #60daaa;
  -webkit-transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
  transition: width 0.25s ease-out, height 0.25s ease-out 0.25s;
}
.draw:hover::after {
  border-bottom-color: #60daaa;
  border-left-color: #60daaa;
  -webkit-transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s,
    height 0.25s ease-out 0.75s;
  transition: border-color 0s ease-out 0.5s, width 0.25s ease-out 0.5s,
    height 0.25s ease-out 0.75s;
}

.meet:hover {
  color: #4285f4;
}
.meet::after {
  top: 0;
  left: 0;
}
.meet:hover::before {
  border-top-color: #4285f4;
  border-right-color: #4285f4;
}
.meet:hover::after {
  border-bottom-color: #4285f4;
  border-left-color: #4285f4;
  -webkit-transition: height 0.25s ease-out, width 0.25s ease-out 0.25s;
  transition: height 0.25s ease-out, width 0.25s ease-out 0.25s;
}

.uvpagination li {
  display: inline;
  text-align: center;
}
.uvpagination a {
  float: left;
  display: block;
  font-size: 14px;
  text-decoration: none;
  padding: 5px 12px;
  color: #fff;
  margin-left: -1px;
  border: 1px solid transparent;
  line-height: 1.5;
}
.uvpagination a.active {
  cursor: default;
}
.uvpagination a:active {
  outline: none;
}

.modal-1 li:first-child a {
  -moz-border-radius: 6px 0 0 6px;
  -webkit-border-radius: 6px;
  border-radius: 6px 0 0 6px;
}
.modal-1 li:last-child a {
  -moz-border-radius: 0 6px 6px 0;
  -webkit-border-radius: 0;
  border-radius: 0 6px 6px 0;
}
.modal-1 a {
  border-color: #ddd;
  color: #4285f4;
  background: #fff;
}
.modal-1 a:hover {
  background: #eee;
}
.modal-1 a.active,
.modal-1 a:active {
  border-color: #4285f4;
  background: #4285f4;
  color: #fff;
}

/* .ui.table tfoot th {
  background: transparent;
} */

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #7460ee;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.selectedRow {
  background: #2185d036 !important;
}

.rwd-table {
  margin: 10px auto;
  width: 100%;

  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
  border: 1px solid rgba(34, 36, 38, 0.15);
}

.rwd-table tr:first-child {
  border-top: none;
  background: #f9fafb;
  color: #67757c;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #fff;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: 0.5em;
}

.rwd-table td:last-child {
  margin-bottom: 0.5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #67757c;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table {
  color: #67757c;
  border-radius: 0.4em;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: 0.5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: 0.25em 0.5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    padding: 0.5em !important;
  }
}

/* THE END OF THE IMPORTANT STUFF */

/* Basic Styling */

h1 {
  text-align: center;
  font-size: 2.4em;
  color: #f2f2f2;
}
.container {
  display: block;
  text-align: center;
}
h3 {
  display: inline-block;
  position: relative;
  text-align: center;
  font-size: 1.5em;
  color: #cecece;
}
h3:before {
  content: "\25C0";
  position: absolute;
  left: -50px;
  -webkit-animation: leftRight 2s linear infinite;
  animation: leftRight 2s linear infinite;
}
h3:after {
  content: "\25b6";
  position: absolute;
  right: -50px;
  -webkit-animation: leftRight 2s linear infinite reverse;
  animation: leftRight 2s linear infinite reverse;
}
@-webkit-keyframes leftRight {
  0% {
    -webkit-transform: translateX(0);
  }
  25% {
    -webkit-transform: translateX(-10px);
  }
  75% {
    -webkit-transform: translateX(10px);
  }
  100% {
    -webkit-transform: translateX(0);
  }
}
@keyframes leftRight {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-10px);
  }
  75% {
    transform: translateX(10px);
  }
  100% {
    transform: translateX(0);
  }
}

/*
    Don't look at this last part. It's unnecessary. I was just playing with pixel gradients... Don't judge.
*/
/*
@media screen and (max-width: 601px) {
  .rwd-table tr {
    background-image: -webkit-linear-gradient(left, #428bca 137px, #f5f9fc 1px, #f5f9fc 100%);
    background-image: -moz-linear-gradient(left, #428bca 137px, #f5f9fc 1px, #f5f9fc 100%);
    background-image: -o-linear-gradient(left, #428bca 137px, #f5f9fc 1px, #f5f9fc 100%);
    background-image: -ms-linear-gradient(left, #428bca 137px, #f5f9fc 1px, #f5f9fc 100%);
    background-image: linear-gradient(left, #428bca 137px, #f5f9fc 1px, #f5f9fc 100%);
  }
  .rwd-table tr:nth-child(odd) {
    background-image: -webkit-linear-gradient(left, #428bca 137px, #ebf3f9 1px, #ebf3f9 100%);
    background-image: -moz-linear-gradient(left, #428bca 137px, #ebf3f9 1px, #ebf3f9 100%);
    background-image: -o-linear-gradient(left, #428bca 137px, #ebf3f9 1px, #ebf3f9 100%);
    background-image: -ms-linear-gradient(left, #428bca 137px, #ebf3f9 1px, #ebf3f9 100%);
    background-image: linear-gradient(left, #428bca 137px, #ebf3f9 1px, #ebf3f9 100%);
  }
}*/
</style>

<script>
export default {
  name: "uvDataTable",
  components: {},
  props: ["data", "config", "pageRows"],
  data() {
    return {
      notData:false,
      filter: "",
      selectedPage: 1,
      selectedRow: "",
      selectedRows: [],
    };
  },
  computed: {
    dataFilter() {
      let datosFiltrados = this.sortedData(this.data);
      if (this.filter !== "") {
        let data = [];
        if (this.filter == "") {
          data = datosFiltrados;
        } else {
          this.data.forEach((element) => {
            let returned = 0;

            this.config.fields.forEach((conf) => {
              if (element[conf.dataName]) {
                let dataToCompare = element[conf.dataName];
                /*if(conf.format){
                  dataToCompare = conf.format(element);
                }*/
                if (
                  dataToCompare
                    .toString()
                    .toUpperCase()
                    .includes(this.filter.toUpperCase())
                ) {
                  if (returned == 0) {
                    returned = 1;
                    data.push(element);
                  }
                }
              }
            });
          });
        }

        return data;
      }
      return datosFiltrados;
    },
    pagesShow() {
      let pages = [];
      if (this.pagesNumber == 1) {
        pages.push(1);
      } else if (this.pagesNumber > 1) {
        let cont = 1;
        //let initialCount = if(this.selectedPage==){}
        for (let i = this.selectedPage - 2; i <= this.pagesNumber; i++) {
          if (cont <= 5 && i > 0) {
            pages.push(i);
          }
          cont++;
        }
        if (!pages.includes(this.pagesNumber)) {
          pages.push("...");
          pages.push(this.pagesNumber);
        }
        if (!pages.includes(1)) {
          pages.splice(0, 0, 1);
          pages.splice(1, 0, "...");
        }
      }
      return pages;
    },
    pagesNumber() {
      let pagesNumber = this.dataFilter.length / this.pageRows;
      pagesNumber = Math.ceil(pagesNumber);
      return pagesNumber;
    },
    dataShowed() {
      let pagedData = [];
      let initialRow = this.pageRows * this.selectedPage - this.pageRows;
      let to = this.pageRows * this.selectedPage;
      for (
        let i = initialRow;
        i < this.dataFilter.lenth || i < initialRow + this.pageRows;
        i++
      ) {
        pagedData.push(this.dataFilter[i - 1]);
      }
      return this.dataFilter.slice(initialRow, to);
    },
  },
  methods: {
    startfilter(){
      this.selectedPage = 1;
    },
    sortedData(data) {
      let midata = data;
      if(this.config?.orderByCol){
        midata = midata.sort((a, b) => {
          if(this.config?.orderByCol.Type == "Asc"){
            if(a[this.config?.orderByCol.Field] < b[this.config?.orderByCol.Field]) { return -1;}
            if(a[this.config?.orderByCol.Field] > b[this.config?.orderByCol.Field]) { return  1;}
          }else{
            if(a[this.config?.orderByCol.Field] > b[this.config?.orderByCol.Field]) { return -1;}
            if(a[this.config?.orderByCol.Field] < b[this.config?.orderByCol.Field]) { return  1;}
          }
          return 0;
        });
      }
      return midata;
    },
    selectRow(index) {
      if (this.config.selectableRow) {
        if (this.selectedRow == index) {
          this.selectedRow = "";
        } else {
          this.selectedRow = index;
        }
      }
    },
    selectRows(index) {
      if (this.config.selectableRow) {
        if (this.config.selectConfig) {
          if (this.config.selectConfig.multiSelect) {
            if (this.selectedRows.includes(index)) {
              let position = this.selectedRows.indexOf(index);
              this.selectedRows.splice(position, 1);
            } else {
              this.selectedRows.push(index);
            }
          } else {
            if (this.selectedRows.includes(index)) {
              let position = this.selectedRows.indexOf(index);
              this.selectedRows.splice(position, 1);
            } else {
              this.selectedRows = [];
              this.selectedRows.push(index);
            }
          }
        } else {
          this.$swal(
            "Falta configuracion de UV Data table",
            "Contacte al administrador",
            "error"
          );
        }
      }
    },
    setPage(page) {
      if (page > 0 && page <= this.pagesNumber && this.pages != "...")
        this.selectedPage = page;
    },
    onClickEvent(buttonId, require, limit) {
      if (require && this.selectedRows.length <= 0) {
        this.$swal(
          "Seleccione un registro para continuar con la acción",
          "Antes de continuar selecciona un registro haciendo click sobre el en la tabla",
          "error"
        );
        return false;
      }
      if (limit != 0) {
        if (this.selectedRows.length > limit) {
          this.$swal(
            "Esta opcion solo admite " + limit + " registro a la vez",
            "Antes de continuar selecciona un registro haciendo click sobre el en la tabla",
            "error"
          );
          return false;
        }
      }
      this.$emit("buttonClick", buttonId, this.selectedRows);
    },
    onClickOptions() {
      var elements = document.getElementsByClassName("opt-button");
      let $this = this;
      var myFunction = function () {
        $this.$emit(
          "buttonOptClick",
          this.attributes["data-opt"].value,
          this.attributes["data-ref"].value
        );
      };

      for (var i = 0; i < elements.length; i++) {
        elements[i].onclick = myFunction;

        /*if(elements[i].getAttribute('added') != 'ok'){
                elements[i].addEventListener('click', myFunction, false);
                elements[i].setAttribute("added", "ok")
            }*/
      }
    },
  },
  beforeMount: function () {},
  mounted: function () {
    setTimeout(() => {
      if(this.data.length == 0){
        this.notData = true;
      }
    }, 15000);
    this.onClickOptions();
  },
};
</script>
